import React from "react";
import PatientInfo from "./PatientInfo";
import Section from "./Section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faDownload,
  faFileSignature,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLoaderData, useParams } from "react-router-dom";
import { buildSyspapURI } from "../utils";
import { Button, Dropdown } from "react-bootstrap";
import SignatureModal from "./SignatureModal";
import { ModalContext } from "../contexts/ModalContext";
import PageHeader from "../components/PageHeader";
import PageFooter from "../components/PageFooter";
import IconButton from "../components/IconButton";
import ExternalLinkButton from "../components/ExternalLinkButton";
import SafeHtml from "../components/SafeHtml";

export default function EditPCRS() {
  const {
    pcrsContent,
    patientInfoTable,
    testName,
    patientRedirectUrls,
    language,
    isAmended = false,
  } = useLoaderData();
  const { assessmentID } = useParams();
  const { openModal } = React.useContext(ModalContext);

  function openSignatureModal() {
    openModal(<SignatureModal assessmentID={assessmentID} />);
  }

  const sendUserToSyspapURL = (url) => {
    window.location.href = buildSyspapURI(url);
  };

  return (
    <>
      <PageHeader
        title="Modification d'un rapport PCRS"
        onBack={() => sendUserToSyspapURL(patientRedirectUrls.back)}
      />
      <div className="container-fluid main-content-container pl-0">
        <div className="content-panel">
          <h1 className="text-center mb-4 fw-bold">Rapport PCRS</h1>
          <div className="col-12 mb-4">
            <table className="table text-center mx-auto w-50">
              <tbody>
                {patientInfoTable.map((val, key) => {
                  return (
                    <PatientInfo
                      key={"patient-info-row-" + key}
                      title={val.name}
                      data={val.value}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="col-12 mb-4">
            <h2 className="section-title">
              {language === "en" ? "Test name" : "Nom du test"}
            </h2>
            <SafeHtml html={testName} className="text-lg" />
          </div>
          <div className="col-12 sections-container">
            {pcrsContent.map((val, key) => {
              return (
                <Section
                  key={"section-" + val.id}
                  id={val.id}
                  title={val.name}
                  largeTitle={val.large_title}
                  initialContent={val.content}
                  spaceAfter={val.space_after}
                  assessmentID={assessmentID}
                  isAmended={isAmended}
                />
              );
            })}
          </div>
        </div>
      </div>
      <PageFooter>
        <Dropdown className="my-auto">
          <Dropdown.Toggle
            variant="secondary"
            className="d-flex align-items-center"
          >
            Ouvrir
          </Dropdown.Toggle>
          <Dropdown.Menu className="shadow-lg">
            <Dropdown.Item
              disabled={patientRedirectUrls.hq === ""}
              as={Link}
              to={buildSyspapURI(patientRedirectUrls.hq)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Questionnaire de santé
              <FontAwesomeIcon
                className={"ms-2"}
                icon={faArrowUpRightFromSquare}
              />
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to={buildSyspapURI(patientRedirectUrls.med_profile)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Dossier patient
              <FontAwesomeIcon
                className={"ms-2"}
                icon={faArrowUpRightFromSquare}
              />
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <ExternalLinkButton
          to={buildSyspapURI(patientRedirectUrls.pdf)}
          className="footer-btn btn btn-secondary ms-auto my-auto d-flex align-items-center"
          buttonOnTheLeft={true}
        >
          PDF
        </ExternalLinkButton>
        <IconButton
          icon={faFileSignature}
          variant="primary"
          className="footer-btn signer-btn-white-border ms-2 my-auto d-flex align-items-center"
          onClick={() => openSignatureModal()}
        >
          Signer
        </IconButton>
      </PageFooter>
    </>
  );
}
